<template>
  <div class="container-fixed" style="padding-top: 100px">
    <header>
      <h1 class="text-center">
        {{ $t('common.partnerAdapterErrorHeader') }}
      </h1>
    </header>
    <div class="text-center">
      <span v-html="errorText" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerAdapter',

  props: {
    partner: {
      type: String,
      required: false,
      default: null,
    },
    errorCode: {
      type: String,
      required: true,
    },
  },

  computed: {
    errorText() {
      return this.$tf(`errorcodes.partnerAdapter_${this.errorCode}`, () => this.$t('errorcodes.partnerAdapter_BACKEND_ERROR'));
    }
  }
};
</script>
